import {
  DAYS_PER_YEAR,
  HOURS_PER_DAY,
  MINUTES_PER_HOUR,
} from "./time/time.constants";

export const NA = Symbol("n/a");

const MINUTES_IN_DAY = MINUTES_PER_HOUR * HOURS_PER_DAY;

export const TIME_WINDOWS_MAP = {
  HOUR: MINUTES_PER_HOUR,
  DAY: MINUTES_IN_DAY,
  WEEK: MINUTES_IN_DAY * 7,
  MONTH: MINUTES_IN_DAY * 30,
  THREE_MONTHS: MINUTES_IN_DAY * (DAYS_PER_YEAR / 4),
  SIX_MONTHS: MINUTES_IN_DAY * (DAYS_PER_YEAR / 2),
  YEAR: MINUTES_IN_DAY * DAYS_PER_YEAR,
  THIRTY_YEARS: MINUTES_IN_DAY * DAYS_PER_YEAR * 30,
} as const;

// these time windows are (currently) not displayed in the UI
export const IGNORED_TIME_WINDOWS = [
  TIME_WINDOWS_MAP.DAY,
  TIME_WINDOWS_MAP.THREE_MONTHS,
  TIME_WINDOWS_MAP.SIX_MONTHS,
  TIME_WINDOWS_MAP.THIRTY_YEARS,
] as const;

export const TIME_WINDOWS = Object.values(TIME_WINDOWS_MAP).filter(
  (value) => !IGNORED_TIME_WINDOWS.includes(value)
);

// the (percentages) thresholds used for color-coding the scores'.
// first item is minimal threshold for a "good" score (green)
// second item is minimal threshold for a "medium" score (orange)
// and of course, below that it "bad" (red)
export const SEVERITY_THRESHOLDS = [85, 50] as const;
// URL array separators (in order of preference)

export const URL_ARRAY_SEPARATOR = "-"; // Primary separator (no encoding needed)
export const URL_ARRAY_SEPARATOR_LEGACY_COMMA = ","; // Legacy separator
